import React from "react"
import { Anchor, Flex } from "@mantine/core"

import { useStyles } from "@/components/SkipLink/SkipLink.styles"

export const SkipLink = () => {
    const { classes } = useStyles()

    return (
        <Flex justify="center" className={classes.flex}>
            <Anchor href="#main-content" size="sm" className={classes.anchor}>
                Skip to main content
            </Anchor>
        </Flex>
    )
}
